import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { AllGroupsPage } from '@features/groups/components/pages/AllGroupsPage'
import { DepartmentsTable } from '@features/groups/components/tables/DepartmentsTable'
import { groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/all/departments')({
    component: RouteComponent,
    loader: async ({ context }) => {
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'all', type: 'department' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load departments'>
            <Suspense fallback={<LoadingIndicator resource='all departments'/>}>
                <AllGroupsPage
                    title='All departments'
                    renderTable={(columnPreset) => (
                        <DepartmentsTable
                            columnPreset={columnPreset}
                            mode='all'
                            navMode='id'
                        />
                    )}
                />
            </Suspense>
        </QueryErrorBoundary>
    )
}
